import { useLocation } from "react-router-dom";
import AIInterview from "../../components/interview/aiinterview";
import VetSteps from "../../components/vettest/vetsteps";

export default function Interview() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  
  const isVetFromUrl = searchParams.get('int') === 'vet' || searchParams.get('isVet') === 'true';
  const isVet = isVetFromUrl || location.state?.isVet;
  
  let candidateTestData = location.state?.candidateTestData || {};


  if (isVetFromUrl && !candidateTestData.id) {
    const candidateTestId = searchParams.get('ct');
    if (candidateTestId) {
      candidateTestData.id = candidateTestId;
    }
  }

  if (location.state) {
    candidateTestData = {
      ...candidateTestData,
      id: candidateTestData.id || location.state.candidateTestData?.id,
      email: candidateTestData.email || location.state.email,
      testId: candidateTestData.testId || location.state.candidateTestData?.testId || location.state.testId,
      recruitmentpartnerId: candidateTestData.recruitmentpartnerId || location.state.recruitmentpartnerId,
      testName: location.state.testName,
      userLocation: location.state.userLocation,
    };
  }

 

  if (isVet) {
    return (
      <VetSteps 
        key="vet-test-session" 
        candidateTestData={candidateTestData} 
      />
    );
  }

  return <AIInterview locationState={location.state} />;
}